const employmentOptions=[
    {
        id: 1,
        name: 'Student',
        value: 'student'
    },
    {
        id: 2,
        name: 'Unemployed',
        value: 'unemployed'
    },
    {
        id: 3,
        name: 'Employed',
        value: 'employed'
    },
    {
        id: 4,
        name: 'Self-Employed',
        value: 'self-employed'
    },
    {
        id: 5,
        name: 'Freelancer',
        value: 'freelancer'
    },
    {
        id: 6,
        name: 'Other',
        value: 'other'
    }

]

export default employmentOptions